import { render, staticRenderFns } from "./SnowDropdownItem.vue?vue&type=template&id=058dabf0&"
import script from "./SnowDropdownItem.vue?vue&type=script&lang=js&"
export * from "./SnowDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports